import { render } from "./ContactFR.vue?vue&type=template&id=12662ba5&scoped=true"
import script from "./ContactFR.vue?vue&type=script&lang=js"
export * from "./ContactFR.vue?vue&type=script&lang=js"

import "./ContactFR.vue?vue&type=style&index=0&id=12662ba5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-12662ba5"

export default script